(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit-shared/deposit-input.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit-shared/deposit-input.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const amountChangeAction = svs.accountservicesReact.deposit.store.deposit.actions.amountChangeAction;
const instantPayAmountChange = svs.accountservicesReact.deposit.store.deposit.actions.instantPayAmountChange;
const ControlGroup = svs.ui.reactForm.ControlGroup;
const AmountInput = svs.ui.reactFormInputs.AmountInput;
const DepositCoverageWarning = svs.accountservicesReact.deposit.depositShared.DepositCoverageWarning;
const amountLimits = svs.accountservicesReact.deposit.constants.amountLimits;
const minAmountErrorText = 'Minsta insättningsbelopp är 25 kr.';
const maxAmountErrorText = 'Högsta insättningsbelopp är 25 000 kr.';
const errorMessageDefault = 'Fyll i ett belopp med endast siffror.';
const requiredErrorText = 'Fyll i ett belopp.';
const DepositInput = () => {
  const dispatch = ReactRedux.useDispatch();
  const setDepositAmount = money => dispatch(amountChangeAction(money));
  const depositAmount = ReactRedux.useSelector(state => state.deposit.amount);
  const diffFromBalance = ReactRedux.useSelector(state => {
    var _state$deposit$instan;
    return (_state$deposit$instan = state.deposit.instantPay) === null || _state$deposit$instan === void 0 ? void 0 : _state$deposit$instan.diffFromBalance;
  });
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showCoverageWarning = _React$useState2[0],
    setShowCoverageWarning = _React$useState2[1];
  const handleOnChangeAmount = e => {
    const money = Number.parseInt(e.target.value, 10);
    if (money > 24 && diffFromBalance > money) {
      setShowCoverageWarning(true);
    }
    if (money < 24 || diffFromBalance <= money) {
      setShowCoverageWarning(false);
    }
    if (money > 0) {
      setDepositAmount(money);
      dispatch(instantPayAmountChange(money));
    } else if (isNaN(money)) {
      setDepositAmount('');
    }
  };
  return React.createElement(React.Fragment, null, React.createElement(ControlGroup, {
    className: "f-body line-height-150 margin-xs-bottom",
    isLessSpace: true,
    v2: true
  }, React.createElement(AmountInput, {
    errorMessageDefault: errorMessageDefault,
    errorMessageMax: maxAmountErrorText,
    errorMessageMin: minAmountErrorText,
    errorMessageRequired: requiredErrorText,
    id: "amount",
    inputHelpText: "Minsta ins\xE4ttning 25 kr.",
    isLessSpace: true,
    isRequired: true,
    label: "Belopp att s\xE4tta in",
    max: amountLimits.MAX,
    min: amountLimits.MIN,
    name: "amount",
    onChange: e => handleOnChangeAmount(e),
    step: "1",
    suffix: "kr",
    value: depositAmount
  })), showCoverageWarning && React.createElement(DepositCoverageWarning, null));
};
svs.accountservicesReact.deposit.depositShared.DepositInput = DepositInput;

 })(window);